export function isIndicatorPercentageFormat(format: string | undefined | null): boolean {
  return String(format ?? '').toLowerCase() === 'percentage';
}

/**
 * Engine stores percentage as decimals (0.15 = 15%). Number/currency use raw values.
 * Scale only at display time so format toggles do not multiply stored values repeatedly.
 */
export function blockOutputStoredValueToDisplay(
  rawValue: number | string | null | undefined,
  format: string | undefined | null,
): number {
  const parsed = Number(rawValue);
  if (Number.isNaN(parsed)) return 0;
  return isIndicatorPercentageFormat(format) ? parsed * 100 : parsed;
}

export function blockOutputDisplayText(
  rawValue: number | string | null | undefined,
  format: string | undefined | null,
): string {
  if (rawValue == null || rawValue === '') return '0';
  return `${blockOutputStoredValueToDisplay(rawValue, format)}`;
}
